import { useEventBus } from "@vueuse/core";
const campaignComponentUpdatedEventBusKey = Symbol();
export const campaignComponentUpdatedEvent = useEventBus(campaignComponentUpdatedEventBusKey);
const campaignComponentChangeEventBusKey = Symbol();
export const campaignComponentChangeEvent = useEventBus(campaignComponentChangeEventBusKey);
const campaignComponentListChangeEventBusKey = Symbol();
export const campaignComponentListChangeEvent = useEventBus(campaignComponentListChangeEventBusKey);
const campaignComponentDeletedEventBusKey = Symbol();
export const campaignComponentDeletedEvent = useEventBus(campaignComponentDeletedEventBusKey);
